import { createAction } from '@reduxjs/toolkit';
import { FetchOrganizationVerticals } from './organization-vertical.types';

export const fetchOrganizationVerticalRequested = createAction<FetchOrganizationVerticals>(
  'ORG_VERTICAL/FETCH_ORG_VERTICAL_API_REQUESTED'
);
export const fetchOrganizationVerticalSuccess = createAction<string[]>('ORG_VERTICAL/FETCH_ORG_VERTICAL_API_SUCCESS');
export const fetchOrganizationVerticalFailed = createAction<string[]>('ORG_VERTICAL/FETCH_ORG_VERTICAL_API_FAILED');

export const clearOrganizationVertical = createAction('ORG_VERTICAL/CLEAR_ORG_VERTICAL');